__webpack_require__.p = "/static/fisio_admin/";